<mat-checkbox
    [disabled]="disabled"
    [indeterminate]="indeterminate"
    [color]="color"
    (change)="onCheckboxChanged($event)"
    [checked]="checked"
    [ngClass]="{
      'custom-checkmark': checkmarkColor,
      'custom-fill': fillColor,
      'custom-border': borderColor
    }"
    [style.--custom-checkmark-color]="checkmarkColor"
    [style.--custom-fill-color]="fillColor"
    [style.--custom-border-color]="borderColor">
    <ng-content></ng-content>
</mat-checkbox>
